import * as React from 'react';

const Close = ({
  fill = '#fff',
  width = '13',
  height = '13'
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width + 'px'}
    height={height + 'px'}
    viewBox="0 0 13 13">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M1.667.286 6.5 5.119 11.333.286a.976.976 0 0 1 1.381 1.38L7.881 6.5l4.833 4.833a.976.976 0 1 1-1.38 1.381L6.5 7.881l-4.833 4.833a.976.976 0 0 1-1.381-1.38L5.119 6.5.286 1.667A.976.976 0 1 1 1.666.286z"
        id="close"
        fill={fill}
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export default Close;

export const CloseThin = ({
  fill = '#fff',
  width = '19',
  height = '19'
}: React.SVGProps<SVGSVGElement>) => (
  
  <svg 
    width={width + 'px'}
    height={height + 'px'}
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path 
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.0388 1.7708L17.1196 0.851562L8.9452 9.02596L0.919239 1L0 1.91924L8.02596 9.9452L0.150685 17.8205L1.06992 18.7397L8.9452 10.8644L16.9715 18.8907L17.8907 17.9715L9.86444 9.9452L18.0388 1.7708Z"
      fill={fill}
    />
  </svg>
);
